import React from 'react'
import './page-break.scss'

export default function PageBreak() {
  return <div className="page-break" />
}
